<script>
export default {
  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: String,
      default: "currentColor",
    },
    className: {
      type: String,
      default: "",
    },
  },
};
</script>

<template>
  <svg
    class="chevron"
    :class="{ 'chevron-up': isExpanded, [className]: className }"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L12 15L18 9"
      :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">
$animation-duration: 0.2s;

.chevron {
  transition: transform $animation-duration ease;
}

.chevron-up {
  transform: rotate(180deg);
}
</style>
